import React from "react";

const extractYouTubeId = (url) => {
  const match = url?.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^?&]+)/);
  return match ? match[1] : null;
};

const VideoRenderer = ({ url }) => {
  if (!url) return null;

  const youtubeId = extractYouTubeId(url);

  return (
    <div className=" rounded-lg border border-brand p-2 bg-[#f0ede1] shadow-md">
      {youtubeId ? (
        <div className="relative pb-[56.25%] rounded-md overflow-hidden">
          <iframe
            src={`https://www.youtube.com/embed/${youtubeId}`}
            title="YouTube Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full rounded-md"
          />
        </div>
      ) : url.endsWith(".mp4") ? (
        <video controls className="w-full rounded-md">
          <source src={url} type="video/mp4" />
          Dein Browser unterstützt dieses Video nicht.
        </video>
      ) : (
        <div className="text-xs text-[#EFEBDC]0 text-center py-4">
          ⚠️ Unbekanntes Videoformat
        </div>
      )}
    </div>
  );
};

export default VideoRenderer;
